"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export function ServiceWorkerRegister() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp9, t0);
  return null;
}
function _temp9() {
  if (!("serviceWorker" in navigator)) {
    return;
  }
  if (process.env.NODE_ENV !== "production") {
    navigator.serviceWorker.getRegistrations().then(_temp2);
    if (typeof caches !== "undefined") {
      caches.keys().then(_temp5);
    }
    return;
  }
  const register = _temp8;
  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register);
    return () => window.removeEventListener("load", register);
  }
}
function _temp8() {
  navigator.serviceWorker.register("/sw.js", {
    scope: "/",
    updateViaCache: "none"
  }).then(_temp6, _temp7);
}
function _temp7(err) {
  console.error("Service Worker registration failed: ", err);
}
function _temp6(registration) {
  console.log("Service Worker registration successful with scope: ", registration.scope);
}
function _temp5(names) {
  names.filter(_temp3).forEach(_temp4);
}
function _temp4(name_0) {
  caches.delete(name_0);
}
function _temp3(name) {
  return name.startsWith("clutch-");
}
function _temp2(regs) {
  regs.forEach(_temp);
}
function _temp(reg) {
  reg.unregister();
}